<tool-drawer-container [shouldShowToggleBtn]="false">
  <div class="about-div" class="main-content">
    <div class="title-div">
      <h1>Tools and Analysis</h1>
      <p *ngIf="authService.getRole() !== 'student'; else elseBlock">
        Data driven tools to promote student retention and success.
      </p>
      <ng-template #elseBlock>
        <p>Data driven tools to promote student success.</p>
      </ng-template>
    </div>

    <ng-container [ngSwitch]="currentPicIndex">
      <ng-container *ngFor="let image of images; let i = index">
        <ng-container *ngSwitchCase="i">
          <h3 class="building-name">{{ image.name }}</h3>
          <div
            class="our-goals-div"
            [style.backgroundImage]="'url(' + image.path + ')'"
          ></div>
        </ng-container>
      </ng-container>
    </ng-container>

    <div
      id="success-metrics-section"
      class="tool-section"
      [style.backgroundColor]="env['colors']['tool_btn_inactive']"
      *ngIf="shouldShowModuleBg(toolListService.successMetricsToolListSignal())"
    >
      <div class="tool-header-title">
        <h3>Success Metrics</h3>
        <toolbox-menu
          [toolList]="toolListService.successMetricsToolListSignal()"
        />
      </div>
    </div>
    <div class="goals-wrapper">
      <goals-list
        [goalsList]="toolListService.successMetricsToolListSignal()"
        [showMoreInfoIcon]="true"
      ></goals-list>
    </div>

    <div
      id="admin-support-section"
      class="tool-section"
      [style.backgroundColor]="env['colors']['tool_btn_inactive']"
      *ngIf="shouldShowModuleBg(toolListService.adminSupportToolListSignal())"
    >
      <div class="tool-header-title">
        <h3>Admin Support</h3>
        <toolbox-menu
          [toolList]="toolListService.adminSupportToolListSignal()"
        />
      </div>
    </div>
    <div class="goals-wrapper">
      <goals-list
        [goalsList]="toolListService.adminSupportToolListSignal()"
        [showMoreInfoIcon]="true"
      ></goals-list>
    </div>

    <div
      class="tool-section"
      [style.backgroundColor]="env['colors']['tool_btn_inactive']"
      *ngIf="
        shouldShowModuleBg(toolListService.externalAdminSupportToolListSignal())
      "
    >
      <div class="tool-header-title">
        <h3>Admin Support (External)</h3>
        <toolbox-menu
          [toolList]="toolListService.externalAdminSupportToolListSignal()"
        />
      </div>
    </div>
    <div class="goals-wrapper">
      <goals-list
        [goalsList]="toolListService.externalAdminSupportToolListSignal()"
        [showMoreInfoIcon]="true"
      ></goals-list>
    </div>
  </div>
</tool-drawer-container>
